import { Box, Button, Flex, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import scroll from "scroll"
import scrollDoc from "scroll-doc"
import styled from "styled-components"

const Banner = styled(Box)`
  background: ${(props) => props.theme.colors.black};
  border-radius: 9px;
  display: inline-block;
  padding: 6px 10px;
  text-align: center;
`

const OutOfStockBanner = ({ outOfStockRef }) => {
  const scrollToActions = () => {
    if (outOfStockRef?.current) {
      const page = scrollDoc()
      const offset = outOfStockRef.current.offsetTop - 380
      scroll.top(page, offset)
    }
  }

  return (
    <Flex justifyContent="center">
      <Banner>
        <Typography
          bold
          color="white"
          fontSize="14px"
          letterSpacing="-0.03em"
          lineHeight="16px"
        >
          Oh no! Temporarily Out of Stock
        </Typography>
        <Button
          color="white"
          fontSize="14px"
          fontWeight="700"
          letterSpacing="-0.03em"
          lineHeight="16px"
          onClick={scrollToActions}
          underline
          variant="text"
        >
          Notify Me!
        </Button>
      </Banner>
    </Flex>
  )
}

OutOfStockBanner.propTypes = {
  outOfStockRef: PropTypes.object,
}

export default OutOfStockBanner
